import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function ChampionsMastermindProgram() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: 'mastermind-program',
                    }
                );
                console.log("res: ", res);
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                console.log("error: ", error);
                ShowNotification.error('Fetch page failed ');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Champions Mastermind Program | Elevating the Christian Financial Industry</title>
                <meta name="description" content="Elevate your leadership in the Christian financial industry at the Champions Forum. Join industry champions & discover innovative values-aligned advice." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--get-certified'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

ChampionsMastermindProgram.getLayout = page => <>{page}</>;
ChampionsMastermindProgram.isPublic = true;
